import ColorPalettes from '../../common/Color/ColorPalettes';

export default ColorPalettes;
